import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {faPlus, faEye, faEdit} from "@fortawesome/free-solid-svg-icons";
import {LevelService} from "../../../shared/services/level/level.service";
import {Level} from "../../../shared/classes/level/level";
import {FormControl, Validators, FormGroup} from "@angular/forms";
import {StatesService} from "../../../shared/services/state/states.service";
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from "@ngx-translate/core";
import {AuthenticationService} from "../../../shared/services/authentication/authentication.service";
import {ModalService} from '../../../shared/services/modal/modal.service';


@Component({
    selector: 'app-level-crud',
    templateUrl: './level-crud.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./level-crud.component.css']
})
export class LevelCrudComponent implements OnInit {

    public faPlus = faPlus;
    public faEye = faEye;
    public faEdit = faEdit;
    public showSpinner: boolean;
    @Input('levelId') levelId = null;
    @Input('mode') mode = null;
    public level: Level;
    public readOnly: boolean = true;

    public levelForm = new FormGroup({
        name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]),
        email: new FormControl('', [Validators.required, Validators.email]),
        lang: new FormControl('', [Validators.required, Validators.maxLength(2)]),
        active: new FormControl('', [Validators.required]),
    });

    public levelAdressForm = new FormGroup({
        address1: new FormControl(''),
        address2: new FormControl(''),
        zip: new FormControl(''),
        city: new FormControl(''),
        country: new FormControl(''),
        notes: new FormControl('')

    });

    constructor(private modalService: ModalService,
                private levelService: LevelService,
                private toastr: ToastrService,
                public statesService: StatesService,
                private translate: TranslateService,
                public authenticationService: AuthenticationService) {

    }

    ngOnInit() {
        this.level = new Level();
        this.readOnly = this.mode === "read" ? true : false;

    }

    openModal(content) {
        this.modalService.openNgbModal(content, {size: 'lg'});
        if (this.mode !== "create") this.getLevel();

    }


    closeModal() {
        this.modalService.dismissAllNgbModals();
        if (this.mode === "create") this.levelId = null;
        this.level = new Level();
        this.levelForm.reset();
        this.levelAdressForm.reset();

    }

    public get email() {
        return this.levelForm.get('email');
    }


    public getErrorMessageEmail(): string {

        return this.email.errors.required || this.email.errors.email ? this.translate.instant('EMAIL_INVALID') : '';
    }


    public get name() {
        return this.levelForm.get('name');
    }


    public getErrorMessageName(): string {

        if (this.name.errors.required) {
            return this.translate.instant('VALUE_FORM_REQUIRED');
        }

        if (this.name.errors.minlength) {
            return this.translate.instant('LEVEL_NAME_TOO_SHORT');
        }

        if (this.name.errors.maxlength) {
            return this.translate.instant('LEVEL_NAME_TOO_LONG');
        }

        return '';
    }

    public get lang() {
        return this.levelForm.get('lang');
    }

    public getErrorMessageLang(): string {
        return this.lang.errors.required ? this.translate.instant('FORM_VALUE_MANDATORY') : '';
    }

    public levelHasChanged(): boolean {
        let changes = 0;
        changes = this.level.name !== this.levelForm.value.name ? changes + 1 : changes;
        changes = this.level.email !== this.levelForm.value.email ? changes + 1 : changes;
        changes = this.level.lang !== this.levelForm.value.lang ? changes + 1 : changes;
        changes = this.level.active !== this.levelForm.value.active ? changes + 1 : changes;
        changes = this.level.description.street !== this.levelAdressForm.value.address1 ? changes + 1 : changes;
        changes = this.level.description.supplement !== this.levelAdressForm.value.address2 ? changes + 1 : changes;
        changes = this.level.description.zipcode !== this.levelAdressForm.value.zip ? changes + 1 : changes;
        changes = this.level.description.city !== this.levelAdressForm.value.city ? changes + 1 : changes;
        changes = this.level.description.country !== this.levelAdressForm.value.country ? changes + 1 : changes;
        changes = this.level.description.notes !== this.levelAdressForm.value.notes ? changes + 1 : changes;
        return changes > 0;

    }


    public persistLevel() {

        if (this.levelForm.valid && this.levelAdressForm.valid) {
            if (this.levelHasChanged()) {
                this.showSpinner = true;

                this.level.name = this.levelForm.value.name;
                this.level.email = this.levelForm.value.email;
                this.level.lang = this.levelForm.value.lang;
                this.level.active = this.levelForm.value.active;

                this.level.description.street = this.levelAdressForm.value.address1;
                this.level.description.supplement = this.levelAdressForm.value.address2;
                this.level.description.zipcode = this.levelAdressForm.value.zip;
                this.level.description.city = this.levelAdressForm.value.city;
                this.level.description.country = this.levelAdressForm.value.country;
                this.level.description.notes = this.levelAdressForm.value.notes;


                if (this.levelId !== null) {

                    this.levelService.patchLevel(this.levelId, this.level)
                        .subscribe((data: any) => {
                            this.setLevel(data);
                            this.statesService.reloadLevelSelector.next();
                            this.statesService.reloadListLevel.next();
                            this.toastr.success(this.translate.instant('LEVEL_MODIFIED'), this.translate.instant('SUCCESS'));
                            this.closeModal();
                        });


                } else if (this.levelId === null) {

                    this.level.level = this.authenticationService.getUserLevel() + 1;
                    this.level.parent = this.authenticationService.getUserLevelId();

                    this.levelService.postLevel(this.level)
                        .subscribe((data: any) => {
                            this.setLevel(data);
                            this.statesService.reloadLevelSelector.next();
                            this.statesService.reloadListLevel.next();
                            this.toastr.success(this.translate.instant('LEVEL_CREATED'), this.translate.instant('SUCCESS'));
                            this.closeModal();
                        });
                }
            } else {
                this.toastr.error(this.translate.instant('SAVING_DISABLED_MESSAGE'), this.translate.instant('ERROR'));
            }
        }

    }

    private getLevel() {
        if (this.levelId !== null) {

            this.showSpinner = true;

            this.levelService.getLevel(this.levelId).subscribe((level: any) => {
                this.setLevel(level);

            });
        }
    }


    private setLevel(data: any) {

        this.level.setLevel(data);

        this.levelForm.patchValue({
            email: this.level.email,
            lang: this.level.lang,
            name: this.level.name,
            active: this.level.active
        });

        this.levelAdressForm.patchValue({

            address1: this.level.description.street,
            address2: this.level.description.supplement,
            zip: this.level.description.zipcode,
            city: this.level.description.city,
            country: this.level.description.country,
            notes: this.level.description.notes
        });

        this.showSpinner = false;

    }

}
